import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';

const fsurveySignupFormSuccess = ($form, response, alohaV2 = false) => {
  const redirect = $form.data('redirect');
  const email = $form.find('input[name^="email"]').val();
  const company = $form.find('.company-form').val() || null;
  const emailHash = SiteUtilities.getShaHash(email);
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const geoLocation = LocationUtilities.getGeoLocation();
  SiteUtilities.configureAssetId($form, 'fsurvey');

  const signupResponse = response['product_signup_response'];
  const redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
  const accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : '';

  // Freshmarketer Data. We are passing email, contactable. Other fields will be sent by the product endpoint.
  const freshmarketerData = {
    freshmarketerObject: {
      email: email,
      company: company,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val() || ''
      },
      domainUrl: redirectUrl,
      product: 'Freshsurvey',
      accountId: accountId,
      composite_stitching_key: response.composite_stitching_key || null
    }
  };

  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshsurvey');

  // Redirect to thank-you page once Freshmarketer Post is complete.
  jQuery.when(
    SiteUtilities.freshmarketerPost(freshmarketerData, false, $form)
  ).then(function () {
    localStorage.setItem('fmarketerEndTime', new Date().toISOString());
    // errorWrapper.removeClass('error');
    localStorage.setItem('redirect_url', redirectUrl);
    let thankYouRedirect = `${redirect}/?account_id=${accountId}&ehash=${emailHash}`;
    if (isExternalIframeSignup) {
      thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
      if (currentReferrer) {
        thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
      }
    }
    localStorage.setItem('thankyouRedirectStartTime', new Date().toISOString());
    window.location.href = thankYouRedirect;
  });
};

var fsurveyLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('.domain-form').val();
  const subdomainProduct = $form.find('.subdomain-product').val().trim();
  if (!domain || !subdomainProduct) return;
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  window.location.href = `https://${domain}${subdomainProduct}`;
  GA4Utilities.loginFormSubmit(domain);
};

var fsurveyForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://api.freshsurvey.io/api/v1/forgot_domain?email=';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  $.ajax({
    url: forgotDomainUrl + encodeURIComponent(email),
    type: 'GET',
    success: (response) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.find('.email-form').parents('.form-field').addClass('error');
      $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
    }
  });
};

export default {
  fsurveyLoginForm,
  fsurveyForgotDomainForm,
  fsurveySignupFormSuccess
};
